import processProxy from "@/env/processProxy";
import { RaiffeisenLeadStatusResponse } from "@/models/integrations/RaiffeisenLoanApplication";
import { FpAxios } from "@/services/FpAxios";

class RaiffeisenApi {
  private raiffeisenAxios = FpAxios.create({baseURL: processProxy.VUE_APP_BASE_RAIFFEISEN_URL});

  async getRaiffeisenLeadStatus(leadId: string): Promise<RaiffeisenLeadStatusResponse> {
    const response = await this.raiffeisenAxios.get(`lead/${leadId}/status`);
    return response.data;
  }
}

export default new RaiffeisenApi();